import React, { useState } from 'react';
import { LegalModal } from './ui/LegalModal';
export function Footer() {
  const [openModal, setOpenModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-[#050a0f] border-t border-[#c8c0b0]/10 py-10 px-4" data-id="element-27">
        <div className="max-w-6xl mx-auto flex flex-col items-center gap-4 text-center" data-id="element-28">
          <p className="font-mono text-[#c8c0b0]/30 text-xs tracking-widest" data-id="element-29">
            © 2026 HOW TO PLAY THE GAME. ALL RIGHTS RESERVED.
          </p>
          <p className="font-mono text-[#c8c0b0]/20 text-xs" data-id="element-30">
            SYSTEM VERSION 4.0.1 // SIMULATION_ID: EARTH_PRIME
          </p>
          <div className="flex items-center gap-6 mt-2" data-id="element-31">
            <button onClick={() => setOpenModal('privacy')} className="text-xs font-mono text-[#c8c0b0]/40 hover:text-[#00d4ff] transition-colors duration-200 tracking-widest uppercase" data-id="element-32">
              Privacy Policy
            </button>
            <span className="text-[#c8c0b0]/20 text-xs" data-id="element-33">|</span>
            <button onClick={() => setOpenModal('terms')} className="text-xs font-mono text-[#c8c0b0]/40 hover:text-[#00d4ff] transition-colors duration-200 tracking-widest uppercase" data-id="element-34">
              Terms of Service
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Privacy Policy" data-id="element-35">
        <p className="text-[#00d4ff]/70 font-mono text-xs" data-id="element-36">
          Last updated: {new Date().getFullYear()}
        </p>

        <h3 className="text-[#c9a84c] font-semibold mt-4" data-id="element-37">
          1. Information We Collect
        </h3>
        <p data-id="element-38">
          When you purchase or access our digital products, we collect only the
          information necessary to process your transaction and deliver your
          order. This may include your name and email address as provided
          through our payment processor.
        </p>

        <h3 className="text-[#c9a84c] font-semibold mt-4" data-id="element-39">
          2. How We Use Your Information
        </h3>
        <p data-id="element-40">
          Your information is used solely to fulfill your order, deliver digital
          products, and send relevant updates about your purchase. We do not
          sell, rent, or share your personal data with third parties for
          marketing purposes.
        </p>

        <h3 className="text-[#c9a84c] font-semibold mt-4" data-id="element-41">
          3. Data Storage & Security
        </h3>
        <p data-id="element-42">
          All transactions are processed through secure, encrypted payment
          gateways. We do not store your payment information on our servers.
          Your personal data is stored securely and protected against
          unauthorized access.
        </p>

        <h3 className="text-[#c9a84c] font-semibold mt-4" data-id="element-43">4. Cookies</h3>
        <p data-id="element-44">
          This site may use essential cookies to ensure proper functionality. No
          tracking or advertising cookies are used without your consent. You may
          disable cookies in your browser settings at any time.
        </p>

        <h3 className="text-[#c9a84c] font-semibold mt-4" data-id="element-45">
          5. Third-Party Services
        </h3>
        <p data-id="element-46">
          We use trusted third-party services for payment processing and digital
          delivery. These services have their own privacy policies and handle
          your data in accordance with applicable laws.
        </p>

        <h3 className="text-[#c9a84c] font-semibold mt-4" data-id="element-47">6. Your Rights</h3>
        <p data-id="element-48">
          You have the right to access, correct, or request deletion of your
          personal data at any time. You may also opt out of any communications
          from us by following the unsubscribe instructions included in any
          email we send.
        </p>

        <h3 className="text-[#c9a84c] font-semibold mt-4" data-id="element-49">
          7. Changes to This Policy
        </h3>
        <p data-id="element-50">
          We reserve the right to update this Privacy Policy at any time.
          Changes will be posted on this page with an updated revision date.
          Continued use of our products constitutes acceptance of the updated
          policy.
        </p>
      </LegalModal>

      {/* Terms of Service Modal */}
      <LegalModal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Terms of Service" data-id="element-51">
        <p className="text-[#00d4ff]/70 font-mono text-xs" data-id="element-52">
          Last updated: {new Date().getFullYear()}
        </p>

        <h3 className="text-[#c9a84c] font-semibold mt-4" data-id="element-53">
          1. Acceptance of Terms
        </h3>
        <p data-id="element-54">
          By purchasing or accessing "The True Game" digital products, you agree
          to be bound by these Terms of Service. If you do not agree to these
          terms, please do not proceed with your purchase.
        </p>

        <h3 className="text-[#c9a84c] font-semibold mt-4" data-id="element-55">
          2. Digital Products & License
        </h3>
        <p data-id="element-56">
          Upon purchase, you are granted a personal, non-exclusive,
          non-transferable license to access and use the digital content for
          your own personal, non-commercial purposes. You may not reproduce,
          distribute, or resell any part of the content.
        </p>

        <h3 className="text-[#c9a84c] font-semibold mt-4" data-id="element-57">
          3. Intellectual Property
        </h3>
        <p data-id="element-58">
          All content within "The True Game" intelligence bundle—including text,
          graphics, concepts, and frameworks—is the exclusive intellectual
          property of its creators. Unauthorized reproduction or distribution is
          strictly prohibited.
        </p>

        <h3 className="text-[#c9a84c] font-semibold mt-4" data-id="element-59">4. Refund Policy</h3>
        <p data-id="element-60">
          Due to the digital nature of our products, all sales are final. We
          stand behind the quality of our content. If you experience a technical
          issue preventing access to your purchase, we will work to resolve it
          promptly.
        </p>

        <h3 className="text-[#c9a84c] font-semibold mt-4" data-id="element-61">
          5. Disclaimer of Warranties
        </h3>
        <p data-id="element-62">
          The content provided is for educational and informational purposes
          only. Results may vary. We make no guarantees regarding specific
          outcomes from using the material. The information is not a substitute
          for professional advice.
        </p>

        <h3 className="text-[#c9a84c] font-semibold mt-4" data-id="element-63">
          6. Limitation of Liability
        </h3>
        <p data-id="element-64">
          To the fullest extent permitted by law, we shall not be liable for any
          indirect, incidental, or consequential damages arising from your use
          of our digital products. Our total liability shall not exceed the
          amount paid for the product.
        </p>

        <h3 className="text-[#c9a84c] font-semibold mt-4" data-id="element-65">7. Governing Law</h3>
        <p data-id="element-66">
          These Terms shall be governed by and construed in accordance with
          applicable laws. Any disputes shall be resolved through binding
          arbitration rather than in court, except where prohibited by law.
        </p>

        <h3 className="text-[#c9a84c] font-semibold mt-4" data-id="element-67">8. Modifications</h3>
        <p data-id="element-68">
          We reserve the right to modify these Terms at any time. Your continued
          use of our products following any changes constitutes your acceptance
          of the new Terms.
        </p>
      </LegalModal>
    </>;
}